// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a21e3470","389":"ea21df7a","455":"405947ec","977":"b871dcf8"}[chunkId] + ".chunk.js";
};